"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = IconCornerLeftUp;

var _react = _interopRequireDefault(require("react"));

var _style = _interopRequireDefault(require("../style"));

var _ref =
/*#__PURE__*/
_react["default"].createElement("g", null, _react["default"].createElement("path", {
  d: "M18 17h-5a1 1 0 0 1-1-1V7.08l3.38 2.7A1 1 0 0 0 16 10a1 1 0 0 0 .78-.38 1 1 0 0 0-.16-1.4l-5-4a1 1 0 0 0-1.24 0l-5 4a1 1 0 0 0 1.24 1.56L10 7.08V16a3 3 0 0 0 3 3h5a1 1 0 0 0 0-2z"
}));

function IconCornerLeftUp(props) {
  return _react["default"].createElement("svg", {
    style: props.customStyle || _style["default"],
    className: props.className,
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    stroke: "none",
    preserveAspectRatio: "xMaxYMid slice",
    focusable: "false",
    "data-cabanaico": true
  }, _ref);
}